import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import {
  IPayableSchema,
  IWorkLog,
  WorkLogStatus
} from "@wingspanhq/payments/dist/interfaces";

type GetWorkLogStatusCellPropsParams = {
  workLog: IWorkLog;
  payable?: IPayableSchema;
};

export function getWorkLogPayerStatusCellProps({
  workLog,
  payable
}: GetWorkLogStatusCellPropsParams): WSTableCellProps {
  switch (workLog.status) {
    case WorkLogStatus.Approved:
      return {
        secondaryText: payable
          ? `Invoiced #${payable.invoiceNumber}`
          : undefined,
        pill: {
          text: "Submitted",
          theme: "success",
          icon: "check-circle"
        }
      };

    case WorkLogStatus.Draft:
    default:
      return {
        pill: {
          text: "Draft",
          theme: "neutral",
          icon: "draft"
        }
      };
  }
}
